const css = `.n3r5Ja__sessionInfo{text-overflow:ellipsis;white-space:nowrap;flex:50%;overflow:hidden}.n3r5Ja__sessionInfoFlex{overflow:hidden}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"sessionInfo":"n3r5Ja__sessionInfo","sessionInfoFlex":"n3r5Ja__sessionInfoFlex"};
